<script setup>
import { ref } from 'vue';

import AppMenuItem from './AppMenuItem.vue';

const model = ref([
    {
        label: 'Home',
        items: [{ label: 'Home', icon: 'pi pi-fw pi-home', to: '/' }]
    },
    {
        label: 'Autoresponder',
        items: [
            { label: 'Basic', icon: 'pi pi-fw pi-envelope', to: '/autoresponder' },
            { label: 'Advanced', icon: 'pi pi-fw pi-envelope', to: '/emails-flow' },
            { label: 'Failed Payment Flow', materialIcon: 'outgoing_mail', to: '/retention-flow' },
        ]
    },
    {
        label: 'CTAs/Buttons/Popups',
        items: [
            { label: 'Auto Display', materialIcon: 'call_to_action', to: '/cta' },
            { label: 'Manually Added Buttons', materialIcon: 'newspaper', to: '/buttons-wizard' },
        ]
    },
    {
        label: 'Tip Jar',
        items: [
            { label: 'Tip Jar', icon: 'pi pi-fw pi-dollar', to: '/tip-jar' },
        ]
    },
    {
        label: 'Reports & Activity',
        items: [
            { label: 'Report Recipients', materialIcon: 'person_alert', to: '/report-recipients' },
            { label: 'Notifications', icon: 'pi pi-fw pi-bell', to: '/notifications' },
            { label: 'Outpost Dashboard', icon: 'pi pi-fw pi-chart-bar', to: '/outpost-dashboard' },
            { label: 'Plausible Dashboard', icon: 'pi pi-fw pi-chart-bar', to: '/plausible-dashboard' },
            { label: 'Activity Log', materialIcon: 'manage_search', to: '/events-log' },
        ]
    },
    {
        label: 'Subscriptions',
        items: [
            { label: 'Ghost Offers', icon: 'pi pi-fw pi-book', to: '/offers' },
            { label: 'Outpost Promotions', icon: 'pi pi-fw pi-ticket', to: '/promotions' },
            { label: '1 Person Subscription', icon: 'pi pi-fw pi-user', to: '/one-person-subscriptions' },
            { label: 'Institutional Subscriptions', icon: 'pi pi-fw pi-users', to: '/institutional-subscriptions' },
            { label: 'Group Subscriptions', icon: 'pi pi-fw pi-users', to: '/group-subscriptions' },
            { label: 'Gift Subscriptions', icon: 'pi pi-fw pi-gift', to: '/gift-subscriptions-settings' },
            { label: 'Default Plans', icon: 'pi pi-fw pi-cog', to: '/default-plans' },
        ]
    },
    {
        label: 'Posts',
        items: [
            { label: 'Trending Posts', materialIcon: 'trending_up', to: '/posts-trending' },
        ]
    },
    {
        label: 'Members',
        items: [
            { label: 'Members', icon: 'pi pi-fw pi-list', to: '/members' },
            { label: 'Clean Up', icon: 'pi pi-fw pi-eraser', to: '/members-cleanup' },
        ]
    },
    {
        label: 'Integrations and Core Connections',
        items: [
            { label: 'Integrations', icon: 'pi pi-fw pi-sitemap', to: '/site-integrations' },
            { label: 'Core Connections', icon: 'pi pi-fw pi-exclamation-circle', to: '/core-connections' },
        ]
    },
    {
        label: 'Email Settings',
        items: [
            { label: 'Templates', materialIcon: 'wysiwyg', to: '/email-templates' },
            { label: 'Design & Settings', icon: 'pi pi-fw pi-cog', to: '/email-template-settings' },
            { label: 'DNS Settings', materialIcon: 'dns', to: '/site-custom-sending-domain' },
        ]
    },
    {
        label: 'Labs',
        items: [
            { label: 'Sponsorship Boxes', icon: 'pi pi-fw pi-box', to: '/sponsorship-boxes' },
            { label: 'Gated PDF and E-Book Magnet', icon: 'pi pi-fw pi-box', to: '/gated-pdf' },
            { label: 'Metered Registration Wall and Metered Paywall', icon: 'pi pi-fw pi-box', to: '/posts-paywall' },
            { label: 'In-Post Ad Inserter', icon: 'pi pi-fw pi-box', to: '/ad-tool' },
            { label: 'Event Creator', icon: 'pi pi-fw pi-box', to: '/posts-events' },
        ]
    },
    {
        label: 'Account',
        items: [
            { label: 'Publication Details', icon: 'pi pi-fw pi-id-card', to: '/site-settings' },
            { label: 'Staff', icon: 'pi pi-fw pi-check-square', to: '/site-staff' },
            { label: 'Export', icon: 'pi pi-fw pi-file-export', to: '/site-export' },
        ]
    },
]);
</script>

<template>
    <ul class="layout-menu">
        <template v-for="(item, i) in model" :key="item">
            <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
            <li v-if="item.separator" class="menu-separator"></li>
        </template>
    </ul>
</template>

<style lang="scss" scoped></style>
